module.exports = __webpack_public_path__ + "img/125ne.44fea904.svg";